module.exports = __webpack_public_path__ + "img/action_duplica.d6b25f27.svg";